import React from 'react'
import styled from 'styled-components'
import Amount from '../Confirm/Amount'

export default () => {
    return (
        <div>
            <LTCDiv>
                <LitecoinBox>
                    <LitecoinSymbol>
                        Ł
                 </LitecoinSymbol>
                </LitecoinBox>
            </LTCDiv>
            <Amount />
        </div>
    )
}

const LitecoinBox = styled.div`
	height: 48px;
	width: 48px;
	border: 1px solid rgba(51,51,51,0.1);
	border-radius: 8px;
	background-color: #CCCCCC;
    box-shadow: 0 1px 2px 0 rgba(0,0,0,0.2);
    display: flex;
    align-items: center;
    justify-content: center;
`

const LitecoinSymbol = styled.p`
    color: white;
    font-family: 'Ubuntu', sans-serif;
    font-style: italic;
    font-size: 35px;
`

const LTCDiv = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`